import { jsxs as l, jsx as r } from "react/jsx-runtime";
import { ModalBody as a } from "./components/ModalBody.js";
import { ModalHeader as e } from "./components/ModalHeader.js";
import { ModalShell as i } from "./components/ModalShell.js";
const M = ({ children: d, title: o, ...m }) => /* @__PURE__ */ l(i, { title: o, ...m, children: [
  /* @__PURE__ */ r(e, { children: o }),
  /* @__PURE__ */ r(a, { children: d })
] });
export {
  M as Modal
};
//# sourceMappingURL=Modal.js.map
